import { FormStep } from '@dgx-pr-spa/shared/util';
import { createAction, props } from '@ngrx/store';

export const updateActiveFormStep = createAction(
  '[Complete Order] Update active form step',
  props<{ payload?: FormStep }>()
);

export type StepperActions = typeof updateActiveFormStep;
